__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "essentials-web-client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@bluebeam/react-i18n", "2.1.0", () => (Promise.all([__webpack_require__.e(672), __webpack_require__.e(329), __webpack_require__.e(891)]).then(() => (() => (__webpack_require__(80672))))));
			register("@bluebeam/react-skyline", "6.3.2", () => (Promise.all([__webpack_require__.e(806), __webpack_require__.e(3), __webpack_require__.e(329), __webpack_require__.e(674), __webpack_require__.e(945)]).then(() => (() => (__webpack_require__(41003))))));
			register("@emotion/react", "11.10.4", () => (Promise.all([__webpack_require__.e(943), __webpack_require__.e(329), __webpack_require__.e(551)]).then(() => (() => (__webpack_require__(69551))))));
			register("@sentry/browser", "7.113.0", () => (Promise.all([__webpack_require__.e(330), __webpack_require__.e(402)]).then(() => (() => (__webpack_require__(95402))))));
			register("@sentry/react", "7.113.0", () => (Promise.all([__webpack_require__.e(330), __webpack_require__.e(329), __webpack_require__.e(465), __webpack_require__.e(226)]).then(() => (() => (__webpack_require__(60226))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(329), __webpack_require__.e(879)]).then(() => (() => (__webpack_require__(87995))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(926), __webpack_require__.e(329), __webpack_require__.e(195)]).then(() => (() => (__webpack_require__(32926))))));
			register("react", "17.0.2", () => (__webpack_require__.e(496).then(() => (() => (__webpack_require__(59496))))));
			register("xstate", "4.33.6", () => (__webpack_require__.e(386).then(() => (() => (__webpack_require__(60386))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};